import { Controller } from '@hotwired/stimulus';

// Handles category selection and loads products/bundles via Turbo Frame.
// Also handles radio button selection for products/bundles.
//
// The products are loaded from the server when a category is selected,
// rather than filtering pre-loaded items client-side. This is done via
// Turbo Frame to keep the data fresh and reduce initial page load.
//
// See: Examples::BookingProcessController#products_by_category
export default class extends Controller {
  static targets = ['categorySelect', 'productsFrame', 'productItem', 'bundleItem'];
  static values = {
    productsUrl: {
      type: String,
      default: '/examples/booking_process/products_by_category'
    },
    selectedType: String,
    selectedId: Number
  };

  // Called when category dropdown changes - reload Turbo Frame with new category
  categoryChanged(event) {
    const selectedCategory = this.categorySelectTarget.value;
    this.clearSelection();

    if (this.hasProductsFrameTarget) {
      if (selectedCategory) {
        const url = `${this.productsUrlValue}?category=${encodeURIComponent(selectedCategory)}`;
        this.productsFrameTarget.src = url;
      } else {
        // Clear the frame content when no category is selected
        this.productsFrameTarget.innerHTML = '';
        this.productsFrameTarget.removeAttribute('src');
      }
    }
  }

  // Called when a product/bundle radio is selected
  itemSelected(event) {
    const radio = event.target;
    const type = radio.dataset.itemType;
    const id = radio.dataset.itemId;

    console.log('itemSelected called:', { type, id });

    this.selectedTypeValue = type;
    this.selectedIdValue = parseInt(id);

    // Update hidden fields - search in the whole form, not just controller element
    const form = this.element.closest('form');
    const typeField =
      form?.querySelector('[name*="selected_item_type"]') ||
      this.element.querySelector('[name*="selected_item_type"]');
    const idField =
      form?.querySelector('[name*="selected_item_id"]') ||
      this.element.querySelector('[name*="selected_item_id"]');

    console.log('Hidden fields found:', { typeField: !!typeField, idField: !!idField });

    if (typeField) typeField.value = type;
    if (idField) idField.value = id;
  }

  // Clear selection when category changes
  clearSelection() {
    const radios = this.element.querySelectorAll(
      'input[type="radio"][name*="selected_item"]'
    );
    radios.forEach((radio) => (radio.checked = false));

    const typeField = this.element.querySelector('[name*="selected_item_type"]');
    const idField = this.element.querySelector('[name*="selected_item_id"]');

    if (typeField) typeField.value = '';
    if (idField) idField.value = '';

    this.selectedTypeValue = '';
    this.selectedIdValue = 0;
  }
}
